// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flowbite/dist/flowbite.turbo.js";

document.addEventListener('turbo:load', (event) => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }

    gtag('js', new Date());
    gtag('config', 'G-D03DD5819C', { page_location: event.detail.url });
    gtag('event', 'page_view', {
        page_location: event.detail.url,
        send_to: 'G-D03DD5819C',
    });
});
